import type React from "react";

import { useEffect, useMemo } from "react";

import { Address } from "@ton/core";

import { useNetwork, useTonWallet } from "@arc/sdk";

import { useAuth } from "@arc/shared/api/architecton/useAuth";
import { usePlatformFeature } from "@/hooks/platform";

export const AuthLayer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const activeWallet = useTonWallet();
  const { network } = useNetwork();
  const platform = usePlatformFeature();
  const platformData = platform.usePlatformData();
  const telegramData = platform.useTelegramData();
  const { initDataRaw } = telegramData;
  const authType = platformData.platform === "tma" ? "telegram" : "web";

  const authMutation = useAuth();

  const initTon = useMemo(() => {
    if (!activeWallet) return undefined;

    return {
      network,
      address: Address.parse(activeWallet.address).toString({ bounceable: false }),
      publicKey: activeWallet.publicKey,
    };
  }, [network, activeWallet]);

  useEffect(() => {
    authMutation.mutate({
      authType,
      initDataRaw,
      initTon,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authType, initDataRaw, initTon]);

  return children;
};
